// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProfileAdminTools":"iz_a big_vu big_ql big_va big_gy big_kg big_sv","ProfileAdminTools__item":"iz_b"};